import React, { useEffect, Suspense, lazy } from 'react';
import { motion } from 'framer-motion';
import { LuMail, LuClock, LuCalendarDays, LuWrench, LuKeyRound } from 'react-icons/lu';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import CosaOttieni from './components/CosaOttieni';
import SmartServices from './components/SmartServices';
import { CadTeam } from './components/CadDrawings';
import './App.css';
import './siti-landing.css';
import { CONTACT_EMAIL } from './data/site';

const Chatbot = lazy(() => import('./components/Chatbot'));
const ContactForm = lazy(() => import('./components/ContactForm'));

function App() {
  useEffect(() => {
    document.title = 'Tre Lune — Ecosistema digitale per partire e crescere';
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'Siti e gestione, marketing, AI, legale e gare. Un solo team. Preventivo in 24 ore.'
      );
    }
    document.body.classList.add('siti-cad');
    const theme = document.querySelector('meta[name="theme-color"]');
    const prevTheme = theme?.getAttribute('content');
    if (theme) theme.setAttribute('content', '#F6F6F4');
    return () => {
      document.body.classList.remove('siti-cad');
      if (theme && prevTheme) theme.setAttribute('content', prevTheme);
    };
  }, []);

  return (
    <div className="cad-page">
      <div className="cad-grid" aria-hidden="true" />
      <div className="cad-vignette" aria-hidden="true" />

      <Navbar />
      <Hero />

      <CosaOttieni />

      <section id="chi-siamo" className="cad-block">
        <motion.div
          className="cad-block-copy"
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.55 }}
        >
          <p className="cad-kicker">03 · CHI SIAMO</p>
          <h2>Chi siamo</h2>
          <p>
            Tre Lune Technologies è un ecosistema, non un fornitore singolo.
          </p>
          <p>
            Copriamo digitale, case vacanze, crescita, intelligenza artificiale, legale-fiscale e gare. Molti partono da un sito. Restano perché il resto sta nello stesso percorso — dalla costituzione alla campagna, dal chatbot all’appalto.
          </p>
        </motion.div>
        <div className="cad-block-art">
          <CadTeam />
        </div>
      </section>

      <SmartServices />

      <Suspense fallback={null}>
        <ContactForm />
      </Suspense>

      <section className="cad-section" aria-label="Perché affidarti a noi">
        <p className="cad-kicker">05 · PERCHÉ NOI</p>
        <ul className="trust-grid">
          <li>
            <LuClock size={18} aria-hidden="true" />
            <span>Preventivo in 24h</span>
          </li>
          <li>
            <LuWrench size={18} aria-hidden="true" />
            <span>Un solo referente</span>
          </li>
          <li>
            <LuCalendarDays size={18} aria-hidden="true" />
            <span>Sito online in 7–14 giorni</span>
          </li>
          <li>
            <LuKeyRound size={18} aria-hidden="true" />
            <span>Tech, marketing, AI, legal</span>
          </li>
        </ul>
      </section>

      <footer className="footer">
        <div className="container">
          <div className="footer-content">
            <div className="footer-info">
              <span className="text-gradient footer-brand">Tre Lune Technologies</span>
              <div className="footer-contacts">
                <a href={`mailto:${CONTACT_EMAIL}`}>
                  <LuMail aria-hidden="true" /> {CONTACT_EMAIL}
                </a>
              </div>
            </div>
            <nav className="footer-links" aria-label="Piè di pagina">
              <a href="#servizi">Servizi</a>
              <a href="#contatti">Contatti</a>
              <a href="/siti">Siti e gestione</a>
              <a href="/privacy-policy">Privacy</a>
            </nav>
            <p className="footer-copy">© 2026 Tre Lune Technologies. P.IVA 08740380723</p>
          </div>
        </div>
      </footer>

      <Suspense fallback={null}>
        <Chatbot />
      </Suspense>
    </div>
  );
}

export default App;
